module.exports = __webpack_public_path__ + "img/ico_input_search.efe39422.svg";